import { useContext } from "react";

import { headerProvider } from "./HeaderProvider";
import type { HeaderTranslations } from "./HeaderTranslationProvider";

export const useHeaderTranslations = (): HeaderTranslations => {
  const data = useContext(headerProvider);
  if (!data) {
    throw new Error(
      "Header translations can't be null, please add headerProvider",
    );
  }

  return data;
};
